import React, { useState } from "react";
import api from "../../../api/axiosInstance";
import Icon from "../../../components/AppIcon";
import { useNavigate } from "react-router-dom";
const CreateBootcamp = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: "",
    trainer: "",
    category: "",
    price: "",
    date: "",
    seats: ""
  });

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await api.post("/api/bootcamp/create-bootcamp", form);

    const { feedbackLink } = res.data;

    alert(`Bootcamp created!\nFeedback Link: ${feedbackLink}`);

    console.log("Feedback Link:", feedbackLink);

    navigate("/admin/bootcamp");

  } catch (err) {
    console.error(err);
    alert("Failed to create bootcamp");
  }
};

  return (

    <div className="p-6">

<button
onClick={() => navigate("/admin/bootcamp")}
className="flex items-center gap-2 text-muted-foreground hover:text-primary"
>
<Icon name="ArrowLeft" size={18}/>
Back
</button>

      <h2 className="text-2xl font-bold mb-6">Create Bootcamp</h2>

      <form onSubmit={handleSubmit} className="grid gap-4 max-w-lg">

        <input
          name="title"
          placeholder="Bootcamp Title"
          className="border p-3 rounded"
          onChange={handleChange}
        />

        <input
          name="trainer"
          placeholder="Trainer"
          className="border p-3 rounded"
          onChange={handleChange}
        />

        <input
          name="category"
          placeholder="Category (Python / SQL / AI)"
          className="border p-3 rounded"
          onChange={handleChange}
        />

        <input
          name="price"
          placeholder="Price"
          className="border p-3 rounded"
          onChange={handleChange}
        />

        <input
          name="date"
          type="date"
          className="border p-3 rounded"
          onChange={handleChange}
        />

        <input
          name="seats"
          placeholder="Seats"
          className="border p-3 rounded"
          onChange={handleChange}
        />

        <button className="bg-primary text-white py-3 rounded">
          Create Bootcamp
        </button>

      </form>

    </div>

  );
};

export default CreateBootcamp;